import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import NProgress from 'nprogress';

NProgress.configure({ showSpinner: false, speed: 300, minimum: 0.2 });

/**
 * Shows a thin progress bar at the top of the page during route transitions.
 * Place inside a Router context.
 */
export function RouteProgress() {
	const location = useLocation();
	const isFirstRender = useRef(true);

	useEffect(() => {
		// Don't show on initial page load
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		NProgress.start();
		// Complete quickly since route component mounts almost immediately
		const timer = setTimeout(() => NProgress.done(), 150);
		return () => {
			clearTimeout(timer);
			NProgress.done();
		};
	}, [location.pathname]);

	return null;
}
